import React from 'react';
import ReactECharts from 'echarts-for-react';

function PieChart({ item }) {
  const option = {
    title: {
      text: item.title.text || '',
      left: 'left',
    },
    tooltip: {
      trigger: 'item',
    },
    legend: {
      orient: 'vertical',
      left: 'right',
    },
    series: [
      {
        // name: 'Access From',
        type: 'pie',
        radius: '50%',
        data: item.data,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };

  return (
    <div style={{ position: 'relative', width: 'auto', height: '400px' }}>
      <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
    </div>
  );
}

export default PieChart;
